import { Star } from "lucide-react";

export const Stars = ({ value = 0, size = 14, className = "" }) => {
  return (
    <div className={`flex items-center gap-0.5 ${className}`}>
      {[1, 2, 3, 4, 5].map((i) => (
        <Star
          key={i}
          size={size}
          className={i <= Math.round(value) ? "fill-kkaccent text-kkaccent" : "text-zinc-300"}
        />
      ))}
    </div>
  );
};
